
export function sendEventLog(eventName) {
  if (window.TiaraTracker && eventName && eventName.length > 0) {
    const eventProps = { te1: eventName };
    window.TiaraTracker.getInstance()
      .trackEvent(eventName)
      .customProps(eventProps)
      .track();
  }
}

export function sendClickLog(click = {}, eventMeta = {}, customProps = {}, actionKind = '') {
  if (window.TiaraTracker) {
    window.TiaraTracker.getInstance()
      .trackEvent('click')
      .actionKind(actionKind)
      .eventMeta(eventMeta)
      .click(click)
      .customProps(customProps)
      .track();
  }
}


// WEBPACK FOOTER //
// ./src/utils/newTiaraUtil.js